import { Routes } from '@angular/router';
import { RouteGuard } from './util/guards/route.guard';

/** Dienstplan mit und ohne Sprungziel (`/:shiftId`), beide auf derselben Komponente. */
function shiftRoutes(
  path: string,
  data: { shiftType: 'evd' | 'responder'; perm: string },
): Routes {
  return ['', '/:shiftId'].map((suffix) => ({
    path: path + suffix,
    loadComponent: () =>
      import('./components/shifts/shift-schedule.component').then(
        (c) => c.ShiftScheduleComponent,
      ),
    canActivate: [RouteGuard],
    data,
  }));
}

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  {
    path: 'login',
    loadComponent: () =>
      import('./components/login/login.component').then(
        (c) => c.LoginComponent,
      ),
  },
  {
    path: 'sso-callback',
    loadComponent: () =>
      import('./util/callback/callback.component').then(
        (c) => c.CallbackComponent,
      ),
  },
  {
    // Bildschirm im Gerätehaus: Geräte-Token statt Anmeldung, Vollbild ohne Navigation.
    path: 'board',
    loadComponent: () =>
      import('./components/board/board-page.component').then(
        (c) => c.BoardPageComponent,
      ),
    data: { kiosk: true },
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./components/home/home.component').then((c) => c.HomeComponent),
    canActivate: [RouteGuard],
  },
  ...shiftRoutes('responder', { shiftType: 'responder', perm: 'responder' }),
  // Ansehen (evd-view, wie die Navigation) oder Eintragen (evd, wie das Backend)
  ...shiftRoutes('evd', { shiftType: 'evd', perm: 'evd-view | evd' }),
  {
    path: 'admin',
    loadChildren: () =>
      import('./components/admin/admin.routes').then((m) => m.adminRoutes),
  },
  {
    path: 'statistics',
    loadChildren: () =>
      import('./components/statistics/statistics.routes').then(
        (m) => m.statisticsRoutes,
      ),
  },
  {
    path: 'guards',
    loadComponent: () =>
      import('./components/guards/guards.component').then(
        (m) => m.GuardsComponent,
      ),
    canActivate: [RouteGuard],
    data: { perm: 'event-watcher' },
  },
  {
    path: 'guards/:eventId',
    loadComponent: () =>
      import('./components/guards/guards.component').then(
        (m) => m.GuardsComponent,
      ),
    canActivate: [RouteGuard],
    data: { perm: 'event-watcher' },
  },
  {
    path: 'event',
    loadChildren: () =>
      import('./components/event/event.routes').then((m) => m.eventRoutes),
  },
  {
    path: 'user',
    loadChildren: () =>
      import('./components/user/user.routes').then((m) => m.userRoutes),
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./components/profile/profile.routes').then(
        (m) => m.profileRoutes,
      ),
  },
  { path: 'settings', redirectTo: 'profile/settings', pathMatch: 'full' },
  {
    path: 'timetracking',
    loadChildren: () =>
      import('./components/time-tracking/time-tracking.routes').then(
        (m) => m.timeTrackingRoutes,
      ),
  },
  {
    path: 'material',
    loadChildren: () =>
      import('./components/equipment/equipment.routes').then(
        (m) => m.EQUIPMENT_ROUTES,
      ),
  },
  {
    path: 'alarms',
    loadChildren: () =>
      import('./components/alarms/alarms.routes').then((m) => m.alarmsRoutes),
  },
  {
    path: '404',
    loadComponent: () =>
      import('./util/error-pages/not-found/not-found.component').then(
        (c) => c.NotFoundComponentComponent,
      ),
  },
  {
    path: '403',
    loadComponent: () =>
      import('./util/error-pages/forbidden/forbidden.component').then(
        (c) => c.ForbiddenComponent,
      ),
  },
  {
    path: '500',
    loadComponent: () =>
      import('./util/error-pages/network-error/network-error.component').then(
        (c) => c.NetworkErrorComponent,
      ),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./util/error-pages/not-found/not-found.component').then(
        (c) => c.NotFoundComponentComponent,
      ),
  },
];
